<template>
  <div v-if="cardioPatient && data && BMI">
    <div class="container container-fluid bg--cardio">
      <h6 class="pull-left text-muted">
        <router-link :to="{ name: 'patientcardio', params: { id: cardioPatient.personId }}">
          &#171; Tillbaka
        </router-link>
      </h6>
      <h1 class="pull-left text-muted">Redigera kardiologpatient</h1>
      <h4 class="pull-left text-muted">{{ cardioPatient.firstName }} {{ cardioPatient.lastName }}</h4>
      <div class="clearfix"></div>
      <!-- Uppgifter -->
      <div class="card journal-card">
        <div class="card-body">
          <p class="text-dark pull-left"><strong>Uppgifter</strong></p>
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label class="pull-left" for="ssn">Personnummer:</label>
                <input type="number"
                  placeholder="YYYYMMDDXXXX"
                  class="form-control"
                  id="ssn"
                  v-model="cardioPatient.ssn"
                  minlength="12">
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="pull-left" for="lastname">Efternamn:</label>
                <input type="text" class="form-control" id="lastname" v-model="cardioPatient.lastName">
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="pull-left" for="firstname">Tilltalsnamn:</label>
                <input type="text" class="form-control" id="firstname" v-model="cardioPatient.firstName">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <!-- Kontaktuppgifter -->
      <div class="card journal-card">
        <div class="card-body">
          <p class="text-dark pull-left"><strong>Kontaktuppgifter</strong></p>
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label class="pull-left" for="email">E-post:</label>
                <input type="email" class="form-control" id="email" v-model="cardioPatient.email">
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="pull-left" for="phonenumber">Telefonnummer:</label>
                <input type="number" class="form-control" id="phonenumber" v-model="cardioPatient.phoneNumber">
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="pull-left" for="clinic--select">Klinik:</label>
                <select class="form-control" id="clinic--select" v-model="cardioPatient.originalClinic">
                  <option :value="null">Välj klinik</option>
                  <option v-for="r in data.clinicMisc.receptionlist" :value="r" :key="r">{{ r }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <!-- Screeningfrågor -->
      <div class="card journal-card">
        <div class="card-body">
          <p class="text-dark pull-left"><strong>Screeningfrågor</strong></p>
          <div class="row">
            <div class="col-sm-12 pull-left">
              <div class="form-group">
                <span class="filter cursor-pointer" v-popover:tooltip.top="data.clinicInfoIcon.scrInclusion">
                  <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                </span>
                <label v-html="data.clinicCardio.screeningReasonForInclusion"></label>
                <br />
                <input type="radio" v-model="inclusionReason"
                 id="inclusionreason_sephia"
                 :value="{ answer: 'I samband med SEPHIA kontroll efter hjärtinfrakt', code: 'inclusionreason_sephia' }">
                <label for="inclusionreason_sephia">
                  I samband med SEPHIA kontroll efter hjärtinfrakt
                </label>
                <br />
                <input type="radio" v-model="inclusionReason"
                 id="inclusionreason_xray"
                 :value="{ answer: 'I samband med genomförd kranskärlsröntgen som visat på aterosklerotisk kranskärlssjukdom', code: 'inclusionreason_xray' }">
                <label for="inclusionreason_xray">
                  I samband med genomförd kranskärlsröntgen som visat på aterosklerotisk kranskärlssjukdom
                </label>
                <br />
                <input type="radio" v-model="inclusionReason"
                 id="inclusionreason_other"
                 :value="{ answer: 'Övriga (diagnos på aterosklerotisk kranskärlssjukdom sedan tidigare)', code: 'inclusionreason_other' }">
                <label for="inclusionreason_other">
                  Övriga (diagnos på aterosklerotisk kranskärlssjukdom sedan tidigare)
                </label>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-sm-12 pull-left">
              <div class="form-group">
                <span class="filter cursor-pointer" v-popover:tooltip.top="data.clinicInfoIcon.scrVegan">
                  <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                </span>
                <label v-html="data.screening.veganHeader"></label>
                <br />
                <input type="radio" :value="true" v-model="veganDiet" id="vegandiet_yes">
                <label for="vegandiet_yes">Ja</label>
                <br />
                <input type="radio" :value="false" v-model="veganDiet" id="vegandiet_no">
                <label for="vegandiet_no">Nej</label>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-sm-12 pull-left">
              <div class="form-group">
                <span class="filter cursor-pointer" v-popover:tooltip.top="data.clinicInfoIcon.scrLchf">
                  <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                </span>
                <label v-html="data.screening.dietHeader"></label>
                <br />
                <input type="radio" :value="true" v-model="lchfDiet" id="lchfdiet_yes">
                <label for="lchfdiet_yes">Ja</label>
                <br />
                <input type="radio" :value="false" v-model="lchfDiet" id="lchfdiet_no">
                <label for="lchfdiet_no">Nej</label>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-sm-12 pull-left">
              <div class="form-group">
                <span class="filter cursor-pointer" v-popover:tooltip.top="data.clinicInfoIcon.scrEgg">
                  <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                </span>
                <label v-html="data.screening.eggheader"></label>
                <br />
                <input type="radio" v-model="eggs" id="more_than_14"
                  :value="{ answer: 'Mer än 14 ägg per vecka', amount: 'more_than_14' }">
                  <label for="more_than_14">Mer än 14 ägg per vecka (2 ägg/dag)</label>
                <br />
                <input type="radio" v-model="eggs" id="less_than_14"
                  :value="{ answer: 'Mindre än 14 ägg per vecka', amount: 'less_than_14' }">
                  <label for="less_than_14">Mindre än 14 ägg per vecka (2 ägg/dag)</label>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-sm-12 pull-left">
              <div class="form-group">
                <span class="filter cursor-pointer" v-popover:tooltip.top="data.clinicInfoIcon.scrSmoker">
                  <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                </span>
                <label v-html="data.clinicCardio.screeningSmoking"></label>
                <br />
                <input type="radio" v-model="smoking"
                 id="smoking_yes" :value="{ answer: 'Ja (pågående)', code: 'smoking_yes' }">
                <label for="smoking_yes">Ja (pågående)</label>
                <br />
                <input type="radio" v-model="smoking"
                 id="smoking_no_former_smoker"
                 :value="{ answer: 'Nej (före detta rökare)', code: 'smoking_no_former_smoker' }">
                <label for="smoking_no_former_smoker">Nej (f.d. rökare)</label>
                <br />
                <input type="radio" v-model="smoking"
                 id="smoking_no_never" :value="{ answer: 'Nej (aldrig rökt)', code: 'smoking_no_never' }">
                <label for="smoking_no_never">Nej (aldrig rökt)</label>
              </div>
            </div>
            <div class="col-sm"></div>
          </div>
          <hr />
          <div class="row">
            <div class="col-sm-12 pull-left">
              <div class="form-group">
                <span class="filter cursor-pointer" v-popover:tooltip.top="data.clinicInfoIcon.scrDiabetes">
                  <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                </span>
                <label v-html="data.clinicCardio.screeningDiabetesTypeOne"></label>
                <br />
                <input type="radio" :value="true" v-model="hasDiabetesTypeOne" id="diabetes_type_one_yes">
                <label for="diabetes_type_one_yes">Ja</label>
                <br />
                <input type="radio" :value="false" v-model="hasDiabetesTypeOne" id="diabetes_type_one_no">
                <label for="diabetes_type_one_no">Nej</label>
              </div>
            </div>
            <div class="col-sm-12 pull-left">
              <div class="form-group">
                <label v-html="data.clinicCardio.screeningDiabetesTypeTwo"></label>
                <br />
                <input type="radio" :value="true" v-model="hasDiabetesTypeTwo" id="diabetes_type_two_yes">
                <label for="diabetes_type_two_yes">Ja</label>
                <br />
                <input type="radio" :value="false" v-model="hasDiabetesTypeTwo" id="diabetes_type_two_no">
                <label for="diabetes_type_two_no">Nej</label>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-sm-12 pull-left">
              <div class="form-group">
                <span class="filter cursor-pointer" v-popover:tooltip.top="data.clinicInfoIcon.scrHypertension">
                  <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                </span>
                <label v-html="data.clinicCardio.screeningHypertension"></label>
                <br />
                <input type="radio" :value="true" v-model="hasHypertension" id="hypertension_yes">
                <label for="hypertension_yes">Ja</label>
                <br />
                <input type="radio" :value="false" v-model="hasHypertension" id="hypertension_no">
                <label for="hypertension_no">Nej</label>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-sm-12 pull-left">
              <!-- PUT /bloodtest -->
              <div class="card card-shadow journal-card">
                <div class="card-body" v-if="!bloodtest">
                  <div class="div-loader">Hämtar blodprov</div>
                </div>
                <div class="card-body" v-if="intervalLists && bloodtest">
                  <div class="row">
                    <div class="col-sm-6">
                      <p class="text-dark pull-left">
                        <strong>Enligt journaluppgifter högsta uppmätta obehandlade LDL kolesterolvärde</strong>
                      </p>
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <span class="input-group-text">LDL</span>
                        </div>
                        <input type="text" class="form-control" v-model="bloodtest.ldlHighestMeasured">
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <p class="text-dark pull-left"><strong>Enhet</strong></p>
                      <div class="input-group mb-3">
                        <input type="text" class="form-control" v-model="bloodtest.ldlUnit" disabled>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <p class="text-dark pull-left"><strong>Referensintervall</strong></p>
                      <div class="input-group mb-3">
                          <select class="form-control" v-model="bloodtest.ldlReferenceInterval">
                            <option :value="''">Välj intervall för LDL</option>
                            <option
                              v-for="(ldl, i) in intervalLists.clinicMisc.ldlRefList"
                              v-html="ldl"
                              :key="i"
                              :title="toElementTitle(ldl)">
                            </option>
                          </select>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col-sm">
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <span class="input-group-text">Provdatum</span>
                        </div>
                        <date-pick v-model="bloodtest.testDate" :displayFormat="'YYYY-MM-DD'"
                        :inputAttributes="{name: bloodtest.testDate, id: 'bloodTestDate', class: ['form-control'],
                          readonly: true, placeholder: 'Välj provdatum'}">
                        </date-pick>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-5">
                      <p class="text-dark pull-left"><strong>Provsvarsresultat</strong></p>
                      <div class="input-group mb-3">
                        <span class="filter icon cursor-pointer"
                          v-if="bloodtest.triglycerider && bloodtest.triglycerider.replace(/,/g, '.') >= 4.5"
                            v-popover:tooltip.top="data.clinicInfoIcon.triglyceridesTooHigh">
                          <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                        </span>
                        <div class="input-group-prepend">
                          <span class="input-group-text">Triglycerider</span>
                        </div>
                        <input type="text" class="form-control" v-model="bloodtest.triglycerider">
                      </div>
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <span class="input-group-text">Totalkolesterol</span>
                        </div>
                        <input type="text" class="form-control" v-model="bloodtest.totalKolesterol">
                      </div>
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <span class="input-group-text">HDL</span>
                        </div>
                        <input type="text" class="form-control" v-model="bloodtest.hdl">
                      </div>
                      <label class="left">Beräknad LDL värde från Friedewalds (om TG&#60;4,5mmol/L)</label>
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <span class="input-group-text">LDL</span>
                        </div>
                        <input type="text" class="form-control"
                          v-model="bloodtest.ldlFriedewalds"
                          :class="(bloodtest.triglycerider && bloodtest.triglycerider.replace(/,/g, '.') >= 4.5) ? 'disable-edit': ''"
                          disabled>
                      </div>
                      <label class="left">LDL värde från direktmätningsmetod (om TG&#62;4,5mmol/L)</label>
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <span class="input-group-text">LDL</span>
                        </div>
                        <input type="text" class="form-control" v-model="bloodtest.ldlUncalculated"
                        :class="(bloodtest.ldlFriedewalds && bloodtest.ldlFriedewalds.length > 0) ? 'disable-edit': ''">
                      </div>
                      <label class="left">Senaste uppmätta Lipoprotein (a) värdet</label>
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <span class="input-group-text">Lipoprotein (a)</span>
                        </div>
                        <input type="text" class="form-control" v-model="bloodtest.lipoProteinA">
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <p class="text-dark pull-left"><strong>Enhet</strong></p>
                      <div class="input-group mb-3">
                        <input type="text" class="form-control" v-model="bloodtest.triglyceriderUnit" disabled>
                      </div>
                      <div class="input-group mb-3">
                        <input type="text" class="form-control" v-model="bloodtest.totalKolesterolUnit" disabled>
                      </div>
                      <div class="input-group mb-3">
                        <input type="text" class="form-control" v-model="bloodtest.hdlUnit" disabled>
                      </div>
                      <div class="input-group mb-1">&nbsp;</div>
                      <div class="input-group mb-3">
                        <input type="text" class="form-control" v-model="bloodtest.ldlUnit" disabled>
                      </div>
                      <div class="input-group mb-2">&nbsp;</div>
                      <div class="input-group mb-3">
                        <input type="text" class="form-control" v-model="bloodtest.ldlUnit" disabled>
                      </div>
                      <div class="input-group mb-1">&nbsp;</div>
                      <div class="input-group mb-3">
                        <select class="form-control m-w-200" v-model="bloodtest.lipoProteinAUnit">
                          <option :value="''">Enhet för Lipoprotein (a)</option>
                          <option
                            v-for="(unit, i) in intervalLists.clinicMisc.lipoproteinRefList"
                            v-html="unit"
                            :key="i"
                            :title="toElementTitle(unit)">
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <p class="text-dark pull-left"><strong>Referensintervall</strong></p>
                      <div class="input-group mb-3">
                          <select class="form-control" v-model="bloodtest.triglyceriderReferenceInterval">
                            <option :value="''">Välj intervall för Triglycerider</option>
                            <option
                              v-for="(t, i) in intervalLists.clinicMisc.triglyceriderRefList"
                              v-html="t"
                              :key="i"
                              :title="toElementTitle(t)">
                            </option>
                          </select>
                      </div>
                      <div class="input-group mb-3">
                          <select class="form-control" v-model="bloodtest.totalKolesterolReferenceInterval">
                            <option :value="''">Välj intervall för Totalkolesterol</option>
                            <option
                              v-for="(tk, i) in intervalLists.clinicMisc.totalkolesterolRefList"
                              v-html="tk"
                              :key="i"
                              :title="toElementTitle(tk)">
                            </option>
                          </select>
                      </div>
                      <div class="input-group mb-3">
                          <select class="form-control" v-model="bloodtest.hdlReferenceInterval">
                            <option :value="''">Välj intervall för HDL</option>
                            <option
                              v-for="(hdl, i) in intervalLists.clinicMisc.hdlRefList"
                              v-html="hdl"
                              :key="i"
                              :title="toElementTitle(hdl)">
                            </option>
                          </select>
                      </div>
                      <div class="input-group mb-1">&nbsp;</div>
                      <div class="input-group mb-3">
                          <select class="form-control" v-model="bloodtest.ldlReferenceInterval">
                            <option :value="''">Välj intervall för LDL</option>
                            <option
                              v-for="(ldl, i) in intervalLists.clinicMisc.ldlRefList"
                              v-html="ldl"
                              :key="i"
                              :title="toElementTitle(ldl)">
                            </option>
                          </select>
                      </div>
                      <div class="input-group mb-2">&nbsp;</div>
                      <div class="input-group mb-3">
                          <select class="form-control" v-model="bloodtest.ldlReferenceInterval">
                            <option :value="''">Välj intervall för LDL</option>
                            <option
                              v-for="(ldl, i) in intervalLists.clinicMisc.ldlRefList"
                              v-html="ldl"
                              :key="i"
                              :title="toElementTitle(ldl)">
                            </option>
                          </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card journal-card" v-if="bloodtest">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label v-html="data.clinicCardio.medicineHeaderCardio"></label>
                          <div v-for="(fhDrug, grouping) in fhDrugsArray" :key="grouping">
                            <p class="text-dark pull-left">
                              <strong>{{ fhDrug.grouping }}</strong>
                            </p>
                            <small class="div-loader" v-if="!drugsAssigned">Mappar läkemedel</small>
                            <select class="form-control"
                            v-model="fhDrug.value.selectedDrug" @change="fhDrug.value.selectedDosage = ''"
                            :disabled="noDrugs">
                              <option :value="''">Välj läkemedel</option>
                              <option
                                v-for="(drug, i) in fhDrug.value.drugsInGroup"
                                v-html="drug.drug"
                                :value="drug"
                                :key="i"
                                :title="toElementTitle(drug.drug)">
                              </option>
                            </select>
                            <select class="form-control" v-model="fhDrug.value.selectedDosage"
                            :disabled="fhDrug.value.selectedDrug == ''">
                              <option :value="''">Välj enhet</option>
                              <option
                                  v-for="(dosages, i) in fhDrug.value.selectedDrug.dosages"
                                v-html="dosages.doseAmount + ' ' + dosages.doseUnit"
                                :value="dosages"
                                :key="i"
                                :title="toElementTitle(dosages.doseAmount + ' ' + dosages.doseUnit)">
                              </option>
                            </select>
                            <p class="text-dark pull-left" v-if="fhDrug.value.selectedDrug.frequency === 'day'">
                              <strong>Enhet avser en tablett per dag</strong>
                            </p>
                            <p class="text-dark pull-left" v-if="fhDrug.value.selectedDrug.frequency === 'byWeekly'">
                              <strong>Enhet avser en injection enligt fast dosinterval</strong>
                            </p>
                            <div class="clearfix"></div>
                          </div>
                          <label for="nodrugs">Patienten tar inga läkemedel:</label> &nbsp;
                          <input type="checkbox" @change="resetFhDrugs()" v-model="noDrugs" id="nodrugs">
                        </div>
                      </div>
                      <div class="col-sm-5">
                        <div class="form-group">
                          <div v-if="drugAnswer === 'Nej'">
                            <h6>Patientens nuvarande läkemedelsbehandling</h6>
                            <table class="table table-bordered table-hover table-drugs">
                              <thead></thead>
                              <tbody>
                                <tr>
                                  <td>Patienten tar inga läkemedel</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div v-if="drugs && drugs.length > 0">
                            <h6>Patientens nuvarande läkemedelsbehandling</h6>
                            <table class="table table-bordered table-hover table-drugs"
                              v-for="drug in drugs" :key="JSON.stringify(drug)">
                              <thead>
                                <tr>
                                  <th v-for="d in Object.keys(drug)" :key="JSON.stringify(d)">
                                    <span v-if="d === 'name'">Namn</span>
                                    <span v-if="d === 'grouping'">Gruppering</span>
                                    <span v-if="d === 'dose'">Dos</span>
                                    <span v-if="d === 'unit'">Enhet</span>
                                    <span v-if="d === 'amountperday'">Antal per dag</span>
                                    <span v-if="d === 'injectionsperweek'">Injektioner per vecka</span>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td v-for="v in drug" :key="v">{{v}}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" v-if="bloodtest">
                      <div class="col-sm-5">
                        <label class="left">Beräknad obehandlat LDL värde</label>
                        <div class="input-group mb-3">
                          <div class="input-group-prepend">
                            <span class="input-group-text">LDL</span>
                          </div>
                          <input type="text" class="form-control disable-edit"
                            v-model="bloodtest.ldlUntreated" disabled>
                        </div>
                      </div>
                      <div class="col-sm-2">
                        <label class="left">&nbsp;</label>
                        <div class="input-group mb-3">
                          <input type="text" class="form-control disable-edit" v-model="bloodtest.ldlUnit" disabled>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm"></div>
          </div>
          <hr />
          <div class="row">
            <div class="col-sm-4 pull-left" v-if="BMI">
              <label v-html="data.clinicCardio.screeningBmi"></label>
              <div class="input-group input-group-sm mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm">Midjemått (cm)</span>
                </div>
                <input type="number" placeholder="Ange värde för midjemått" class="form-control" v-model="BMI.bellyCircumference">
              </div>
              <div class="input-group input-group-sm mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm">Längd (cm)</span>
                </div>
                <input type="number" placeholder="Ange värde för längd" class="form-control" v-model="BMI.height">
              </div>
              <div class="input-group input-group-sm mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm">Vikt (kg)</span>
                </div>
                <input type="number" placeholder="Ange värde för vikt" class="form-control" v-model="BMI.weight">
              </div>
              <div class="input-group input-group-sm mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm">BMI</span>
                </div>
                <input type="text" class="form-control form-control-bmi" v-model="summaryBMI" disabled>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="btn-group">
        <button class="btn btn-lg btn-primary"
          @click="addCardioPatientScreeningAnswers()" :disabled="!isFieldsValid">
        Spara ändringar
        </button>
        <button class="btn btn-lg btn-danger" @click="confirmLeave()">Avbryt</button>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
import config from '../../config/index.js'
import axios from '../plugins/axios'
import FieldId from '../plugins/fieldid'
import { request } from '../plugins/datocms'
import { luhnSsn } from '../plugins/luhnssn'
import { friedewalds } from '../plugins/friedewalds'
import { fhDrugs } from '../plugins/fhdrugs'
import DatePick from 'vue-date-pick'
import $ from 'jquery'
import 'vue-date-pick/dist/vueDatePick.css'

export default {
  name: 'editcardiopatient',
  components: {
    DatePick
  },
  props: ['id'],
  data () {
    return {
      data: null,
      smoking: null,
      inclusionReason: null,
      hasDiabetesTypeOne: null,
      hasDiabetesTypeTwo: null,
      hasHypertension: null,
      screeningAnswers: null,
      eggs: null,
      veganDiet: null,
      lchfDiet: null,
      drugs: null,
      drugAnswer: null,
      noDrugs: null,
      intervalLists: null,
      drugsAssigned: false,
      fhDrugTags: [],
      fhDrugsArray: fhDrugs,
      BMI: {
        bellyCircumference: '',
        height: '',
        weight: ''
      },
      bloodtest: null,
      cardioPatient: null
    }
  },
  methods: {
    toElementTitle (str) {
      if (str) {
        let res = $('<textarea />').html(str).text() // convert special html entity chars
        res = res.replace(/<[^>]*>?/gm, '') // strip html tags
        return res
      }
    },
    toTitleCase (phrase) {
      if (phrase) {
        return phrase
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      }
    },
    confirmLeave () {
      const r = confirm('Är du säker? Du kan ha osparade ändringar.')
      if (r) {
        this.$router.go(-1)
      }
    },
    getFieldId (lbl) {
      return FieldId(lbl)
    },
    getSpecificScreeningAnswer (fieldId) {
      if (this.screeningAnswers && this.screeningAnswers.length > 0) {
        for (let index = 0; index < this.screeningAnswers.length; index++) {
          const screeningAnswer = this.screeningAnswers[index]
          if (screeningAnswer.fieldId === fieldId) {
            const answer = JSON.parse(screeningAnswer.answer)
            return answer
          }
        }
      } else {
        return null
      }
    },
    async getCardioPatientById () {
      axios._get(config.cardioUri + '/byId?PersonId=' + this.$props.id).then(response => {
        this.cardioPatient = response.data.cardioPatientData
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get cardiopatient by id: ' + error)
        }
      })
    },
    async getBloodTest () {
      const temp = {
        testDate: null,
        ldlHighestMeasured: '',
        ldlFriedewalds: '',
        ldlUntreated: '',
        hdl: '',
        totalKolesterol: '',
        triglycerider: '',
        lipoProteinA: '',
        ldlUnit: 'mmol/L',
        hdlUnit: 'mmol/L',
        totalKolesterolUnit: 'mmol/L',
        triglyceriderUnit: 'mmol/L',
        lipoProteinAUnit: '',
        ldlReferenceInterval: '',
        hdlReferenceInterval: '',
        totalKolesterolReferenceInterval: '',
        triglyceriderReferenceInterval: ''
      }
      axios._get(config.bloodtestUri + '?PersonId=' + this.$props.id).then(response => {
        if (response) {
          this.bloodtest = response.data.bloodTest ? response.data.bloodTest : temp
          try {
            const ldl = JSON.parse(this.bloodtest.ldl)
            this.bloodtest.ldlHighestMeasured = ldl.ldlHighestMeasured
            this.bloodtest.ldlFriedewalds = ldl.ldlFriedewalds
            this.bloodtest.ldlUntreated = ldl.ldlUntreated
            this.bloodtest.ldlUncalculated = ldl.ldlUncalculated
          } catch (msg) {
            console.log('Could not parse bloodtest LDL, assigning value directly.')
            this.bloodtest.ldlUncalculated = this.bloodtest.ldl
          }
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get bloodtest for cardiopatient: ' + error)
        }
      })
    },
    async getScreeningAnswers () {
      axios._get(config.screeninganswerUri + '?PersonId=' + this.$props.id).then(response => {
        if (response) {
          this.screeningAnswers = response.data.answers
          this.assignScreeningAnswers()
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get screeninganswers for cardiopatient: ' + error)
        }
      })
    },
    assignFHDrugs () {
      if ((this.fhDrugsArray && this.fhDrugsArray.length > 0) && (this.drugs && this.drugs.length > 0)) {
        this.fhDrugsArray.forEach(fhDrug => {
          this.drugs.forEach(d => {
            let drug = fhDrug.value.drugsInGroup.find(x => x.drug.includes(d.name))
            if (drug) {
              let dosage = drug.dosages.find(y => y.doseAmount === d.dose)
              // add old dosage of praluent if it was previously registered
              if (dosage === undefined &&
                drug.drug.indexOf('Praluent') > 0 &&
                d.dose === '75/150') {
                dosage = {
                  doseAmount: '75/150',
                  doseUnit: 'mg',
                  reductionInMmolL: 0.57,
                  reductionInPercentage: 55,
                  correctionFactor: 2.2
                }
                drug.dosages.push(dosage)
              }
              fhDrug.value.selectedDrug = drug
              fhDrug.value.selectedDosage = dosage
            }
          })
        })
      }
      this.drugsAssigned = true
    },
    assignScreeningAnswers () {
      if (this.getSpecificScreeningAnswer(this.getFieldId('screeningdiabetestype1'))) {
        this.hasDiabetesTypeOne = this.getSpecificScreeningAnswer(this.getFieldId('screeningdiabetestype1')).answer === 'Ja'
      }
      if (this.getSpecificScreeningAnswer(this.getFieldId('screeningdiabetestype2'))) {
        this.hasDiabetesTypeTwo = this.getSpecificScreeningAnswer(this.getFieldId('screeningdiabetestype2')).answer === 'Ja'
      }
      if (this.getSpecificScreeningAnswer(this.getFieldId('screeninghypertension'))) {
        this.hasHypertension = this.getSpecificScreeningAnswer(this.getFieldId('screeninghypertension')).answer === 'Ja'
      }
      if (this.getSpecificScreeningAnswer(this.getFieldId('screeningvegan'))) {
        this.veganDiet = this.getSpecificScreeningAnswer(this.getFieldId('screeningvegan')).answer === 'Ja'
      }
      if (this.getSpecificScreeningAnswer(this.getFieldId('screeningdiet'))) {
        this.lchfDiet = this.getSpecificScreeningAnswer(this.getFieldId('screeningdiet')).answer === 'Ja'
      }
      if (this.getSpecificScreeningAnswer(this.getFieldId('screeningsmoking'))) {
        this.smoking = this.getSpecificScreeningAnswer(this.getFieldId('screeningsmoking')).smoking
      }
      if (this.getSpecificScreeningAnswer(this.getFieldId('screeningreasonforinclusion'))) {
        this.inclusionReason = this.getSpecificScreeningAnswer(this.getFieldId('screeningreasonforinclusion')).reason
      }
      if (this.getSpecificScreeningAnswer(this.getFieldId('screeningegg'))) {
        this.eggs = this.getSpecificScreeningAnswer(this.getFieldId('screeningegg')).eggs
      }
      if (this.getSpecificScreeningAnswer(this.getFieldId('screeningbmi'))) {
        this.BMI = this.getSpecificScreeningAnswer(this.getFieldId('screeningbmi')).values
      }
      if (this.getSpecificScreeningAnswer(this.getFieldId('screeningmedicine_cardio'))) {
        this.drugAnswer = this.getSpecificScreeningAnswer(this.getFieldId('screeningmedicine_cardio')).answer
        this.drugs = this.getSpecificScreeningAnswer(this.getFieldId('screeningmedicine_cardio')).drugs
      }
    },
    convertPropInArray (fhDrugsArray) {
      let drugs = []
      fhDrugsArray.forEach(fhd => {
        if (fhd.value['selectedDosage']) {
          let drug = {
            name: fhd.value['selectedDrug'].drug,
            grouping: fhd.value['selectedDrug'].grouping,
            dose: fhd.value['selectedDosage'].doseAmount,
            unit: fhd.value['selectedDosage'].doseUnit
          }
          if (fhd.value['selectedDrug'].frequency === 'day') {
            drug.amountperday = '1'
          } else {
            drug.injectionsperweek = '1'
          }
          drugs.push(drug)
        }
      })
      if (drugs) {
        return drugs
      }
    },
    calculateUntreatedLDL () {
      if (this.bloodtest) {
        // Select ldl to calculate
        let ldlToCalculate = ''
        if (this.bloodtest.ldlFriedewalds !== '') {
          ldlToCalculate = this.bloodtest.ldlFriedewalds
        } else if (this.bloodtest.ldlUncalculated !== '') {
          ldlToCalculate = this.bloodtest.ldlUncalculated
        } else {
          ldlToCalculate = ''
        }

        // Calculate ldl
        if (ldlToCalculate && ldlToCalculate.toString().length > 0) {
          let calculatedLDL = ldlToCalculate.replace(/,/g, '.')
          this.fhDrugsArray.forEach(fhd => {
            if (fhd.value['selectedDosage']) {
              calculatedLDL *= fhd.value['selectedDosage'].correctionFactor
            }
          })
          if (calculatedLDL && calculatedLDL.toString().length > 0) {
            calculatedLDL = parseFloat(calculatedLDL).toFixed(2)
            this.bloodtest.ldlUntreated = calculatedLDL
          }
        } else {
          this.bloodtest.ldlUntreated = ''
        }
      }
    },
    resetFhDrugs () {
      this.fhDrugsArray.forEach(fhd => {
        fhd.value['selectedDrug'] = ''
        fhd.value['selectedDosage'] = ''
      })
    },
    addCardioPatientScreeningAnswers () {
      const r = confirm('Är du säker på att du vill uppdatera denna kardiologpatient?')
      if (r) {
        let screeningAnswers = [
          {
            personId: this.cardioPatient.personId,
            answer: JSON.stringify({
              question: 'Patienten inkluderas i digifysisk FH screening',
              reason: this.inclusionReason,
              timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
            }),
            fieldId: 6135399 // screeningreasonforinclusion
          },
          {
            personId: this.cardioPatient.personId,
            answer: JSON.stringify({
              question: 'Har patienten hypertoni?',
              answer: (this.hasHypertension ? 'Ja' : 'Nej'),
              timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
            }),
            fieldId: 6132773 // screeninghypertension
          },
          {
            personId: this.cardioPatient.personId,
            answer: JSON.stringify({
              question: 'Patientens midjemått, längd, vikt och BMI',
              values: this.BMI,
              summary: this.summaryBMI,
              timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
            }),
            fieldId: 6132814 // screeningbmi
          },
          {
            personId: this.cardioPatient.personId,
            answer: JSON.stringify({
              question: 'Är patienten rökare?',
              smoking: this.smoking,
              timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
            }),
            fieldId: 5649280 // screeningsmoking
          },
          {
            personId: this.cardioPatient.personId,
            answer: JSON.stringify({
              question: 'Har patienten diabetes typ 1?',
              answer: (this.hasDiabetesTypeOne ? 'Ja' : 'Nej'),
              timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
            }),
            fieldId: 5649270 // screeningdiabetestype1
          },
          {
            personId: this.cardioPatient.personId,
            answer: JSON.stringify({
              question: 'Har patienten diabetes typ 2?',
              answer: (this.hasDiabetesTypeTwo ? 'Ja' : 'Nej'),
              timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
            }),
            fieldId: 5649269 // screeningdiabetestype2
          },
          {
            personId: this.cardioPatient.personId,
            answer: JSON.stringify({
              question: 'Äter du rent vegansk kost?',
              answer: (this.veganDiet ? 'Ja' : 'Nej'),
              timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
            }),
            fieldId: 8963171 // screeningvegan
          },
          {
            personId: this.cardioPatient.personId,
            answer: JSON.stringify({
              question: 'Äter patienten en fettrik kost med få kolhydrater (t.ex. LCHF)?',
              answer: (this.lchfDiet ? 'Ja' : 'Nej'),
              timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
            }),
            fieldId: 1293109 // screeningdiet
          },
          {
            personId: this.cardioPatient.personId,
            answer: JSON.stringify({
              question: 'Hur många ägg äter patienten en genomsnittlig vecka?',
              eggs: this.eggs,
              timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
            }),
            fieldId: 1293536 // screeningegg
          },
          {
            personId: this.cardioPatient.personId,
            answer: JSON.stringify({
              question: 'Har patienten en pågående behandling med kolesterolsänkande läkemedel?',
              answer: (this.noDrugs ? 'Nej' : 'Ja'),
              drugs: (this.noDrugs ? '' : this.convertPropInArray(this.fhDrugsArray)),
              timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
            }),
            fieldId: 5818344 // screeningmedicine_cardio
          }
        ]
        if (screeningAnswers && screeningAnswers.length > 0) {
          axios.postCardioPatientScreeningAnswers(config.screeninganswerUri, screeningAnswers).then((response) => {
            if (response) {
              this.updateBloodTest()
            }
          }, (error) => {
            if (error.response && error.response.status === 401) {
              window.location.href = window.location.origin.concat('/error')
            }
          })
        }
      }
    },
    updateBloodTest () {
      this.bloodtest.personId = this.cardioPatient.personId
      this.bloodtest.ldl = JSON.stringify({
        ldlHighestMeasured: this.bloodtest.ldlHighestMeasured,
        ldlFriedewalds: this.bloodtest.ldlFriedewalds,
        ldlUntreated: this.bloodtest.ldlUntreated,
        ldlUncalculated: this.bloodtest.ldlUncalculated
      })
      axios.putBloodTest(config.bloodtestUri, this.bloodtest).then(response => {
        if (response) {
          this.editCardioPatient()
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not update bloodtest results: ' + error)
        }
      })
    },
    editCardioPatient () {
      let loader = this.$loading.show()
      axios.putCardioPatient(config.cardioUri + config.personalDataUri, this.cardioPatient).then((response) => {
        if (response) {
          setTimeout(() => {
            loader.hide()
            window.location.href = window.location.origin.concat('/patientcardio/' + this.$props.id)
          }, 1000)
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          loader.hide()
          console.log(error)
        }
      })
    }
  },
  watch: {
    bloodtest: {
      handler (bt) {
        if (bt.hdl.length > 0 && bt.totalKolesterol.length > 0 && (bt.triglycerider.length > 0 && bt.triglycerider.replace(/,/g, '.') < 4.5)) {
          this.bloodtest.ldlFriedewalds = friedewalds(
            bt.totalKolesterol.replace(/,/g, '.'), bt.hdl.replace(/,/g, '.'), bt.triglycerider.replace(/,/g, '.')
          )
          this.bloodtest.ldlUncalculated = ''
        } else {
          this.bloodtest.ldlFriedewalds = ''
        }
        this.calculateUntreatedLDL()
      },
      deep: true
    },
    fhDrugsArray: {
      handler (fhd) {
        if (fhd) {
          this.calculateUntreatedLDL()
        }
      },
      deep: true
    },
    drugs: {
      handler (d) {
        if (d && d.length > 0) {
          this.noDrugs = null
        }
      },
      deep: true
    },
    noDrugs (nd) {
      if (nd === false) {
        this.noDrugs = null
      }
    },
    drugAnswer (da) {
      if (da && da === 'Nej') {
        this.noDrugs = true
      }
    }
  },
  computed: {
    isFieldsValid () {
      if (this.validSsn && (this.cardioPatient.firstName && this.cardioPatient.firstName.length !== 0) &&
      (this.cardioPatient.lastName && this.cardioPatient.lastName.length !== 0) &&
      ((this.cardioPatient.email && this.cardioPatient.email.length !== 0) || (this.cardioPatient.phoneNumber &&
      this.cardioPatient.phoneNumber.length >= 8)) && this.smoking !== null && this.inclusionReason !== null &&
      this.hasDiabetesTypeOne !== null && this.hasDiabetesTypeTwo !== null && this.hasHypertension !== null && this.eggs !== null &&
      this.veganDiet !== null && this.lchfDiet !== null && this.summaryBMI.length > 0 && this.cardioPatient.originalClinic !== null) {
        return true
      } else {
        return false
      }
    },
    validSsn () {
      const ssnValid = luhnSsn(this.cardioPatient.ssn)
      return ssnValid
    },
    summaryBMI () {
      if (this.BMI.weight && this.BMI.height) {
        const bmi = this.BMI.weight / (this.BMI.height / 100 * this.BMI.height / 100)
        return bmi.toFixed(2)
      }
      return ''
    }
  },
  async beforeMount () {
    await this.getCardioPatientById()
    await this.getScreeningAnswers()
    await this.getBloodTest()
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          misc {
            facilitylist
          }
          screening {
            veganHeader
            dietHeader
            eggheader
            verifycontactheader
            verifydiagnosisheader
            verifygentestheader
            verifymutationheader
          }
          clinicMisc {
            receptionlist
          }
          clinicCardio {
            screeningReasonForInclusion
            screeningDiabetesTypeOne
            screeningDiabetesTypeTwo
            screeningSmoking
            screeningHypertension
            screeningBmi
            medicineHeaderCardio
          }
          clinicInfoIcon {
            triglyceridesTooHigh
            scrVegan
            scrSmoker
            scrLchf
            scrInclusion
            scrHypertension
            scrEgg
            scrDiabetes
            dlcnGroup1
            dlcnGroup2
            dlcnGroup3
            dlcnGroup4
            dlcnGroup5
          }
        }
      `
    })
    this.intervalLists = await request({
      query: `
        {
          clinicMisc {
            ldlRefList
            hdlRefList
            triglyceriderRefList
            totalkolesterolRefList
            lipoproteinRefList
            mutationlist
            mutationFacilityList
          }
        }
      `
    })
    if (this.data.screening) {
      this.data.screening = JSON.parse(
        JSON.stringify(this.data.screening)
          .replaceAll('du', 'patienten')
          .replaceAll('din', 'patienten')
      )
      this.data.screening.veganHeader = 'Äter patienten ren vegansk kost?'
    }
    setTimeout(() => this.assignFHDrugs(), 5000)
  },
  beforeRouteLeave (to, from, next) {
    if (to.path.includes('/patientscardio/') || to.path.includes('/patientcardio/')) {
      next()
    } else {
      const parts = to.path.split('/')
      const uri = '/' + parts[parts.length - 1]
      window.location.href = window.location.origin + uri
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
button:disabled {
  opacity: 0.3;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
button:disabled {
  opacity: 0.3;
}
input[type=checkbox] {
    transform: scale(1.5);
}
.table {
  background: rgba(255, 255, 255, 0.88);
  border: 2px solid rgba(0, 0, 0, 0.44) !important;
}
.table th {
  border-bottom: 0;
}
.table th, td {
  font-size: 80%;
}
.pull-left {
  text-align: left;
}
.pull-right {
  text-align: right;
}
.form-group-select {
  position: absolute;
  bottom: 0;
}
.bloodtest-div input[type="text"] {
  margin-bottom: 15px !important;
}
.form-control-bloodtest-ldl {
  border: 1px solid rgba(0, 0, 0, 0.185);
  opacity: 0.6;
}
.form-control-ldluntreated {
  background-color: rgba(86, 214, 139, 0.171) !important;
  border: 1px solid rgba(0, 0, 0, 0.485);
}
.journal-card:hover {
  background: #bed4b4;
  border: 1px solid #abc2a0;
  color: #000;
  opacity: 1.0;
}
.journal-card {
  background: #CDE5C3;
  border: 1px solid #b7ccae;
  color: #38362E;
  opacity: 0.8;
}
.card-shadow {
  box-shadow: 2px 2px #888888;
}
.table-drugs {
  background: rgba(255, 255, 255, 0.88);
  border: 2px solid rgba(0, 0, 0, 0.44) !important;
  font-size: 90%;
}
.icon {
  line-height: 33px;
  margin-right: 8px;
}
.disable-edit {
  opacity: 0.55;
  pointer-events: none;
}
.m-w-200 {
  min-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/EditCardioPatient.vue